/**
 * L2-P1: moved to @miq/shared-models (models/iuser.model.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export type { IDelegate, IPrincipalMapping, DistributionGroupUser, IPhone, IRecordAccess, IExportLimits, IUserPermission, UserGroups, CatalogList, CatalogAttributes, IRecordAttrs, UserTheme } from '@miq/shared-models';
export { IUserRequest, IUser, ILocationPermission, UserType, UserRole, UserConfidentiality, DeleteRecordKey, PendingReviewKeyValue, UserGroupEnum } from '@miq/shared-models';
